/* Soft Riot – Effekte: Maus-Spur und fallende Teilchen.
   Wird nur geladen, wenn in den Theme-Einstellungen → Effekte etwas eingeschaltet ist (snippet 'effects'). */
(() => {
  const cfgEl = document.getElementById('fx-config');
  if (!cfgEl) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (_) { return; }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!finePointer && !cfg.mobile) return;

  /* ---------- Zeitplan (deutsche Zeit und Vorschau-Uhr aus der Zeitsteuerung, falls vorhanden) ---------- */
  const TMX = window.SoftRiotTM;
  const today = new Date(TMX ? TMX.now() : Date.now());
  const md = () => {
    if (TMX) { const p = TMX.parts(); return p.m * 100 + p.d; }
    return (today.getMonth() + 1) * 100 + today.getDate();
  };
  const parseDay = (s) => {
    const m = String(s || '').match(/(\d{1,2})\s*\.\s*(\d{1,2})/);
    return m ? Number(m[2]) * 100 + Number(m[1]) : null;
  };
  if (cfg.schedule === 'dates' && (cfg.from || cfg.to)) {
    if (TMX) {
      // Wie die Zeitsteuerung: „01.11.2026 18:00“, „01.11.2026“ oder „01.11.“ (jedes Jahr), deutsche Zeit
      if (!TMX.win(cfg.from, cfg.to)) return;
    } else {
      // Ohne Zeitsteuerung: Tag und Monat, ein Jahr wird ebenfalls beachtet
      const full = (s, end) => {
        const m = String(s || '').match(/(\d{1,2})\s*\.\s*(\d{1,2})\s*\.?\s*(\d{4})?/);
        if (!m) return null;
        return m[3] ? new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]), end ? 23 : 0, end ? 59 : 0).getTime() : null;
      };
      const fy = full(cfg.from);
      const ty = full(cfg.to, true);
      if (fy || ty) {
        const n = Date.now();
        if ((fy && n < fy) || (ty && n > ty)) return;
      } else {
        const from = parseDay(cfg.from);
        const to = parseDay(cfg.to);
        const now = md();
        if (from && to) {
          // Über den Jahreswechsel (z. B. 01.12. – 06.01.) zählt beides
          const inside = from <= to ? now >= from && now <= to : now >= from || now <= to;
          if (!inside) return;
        }
      }
    }
  }

  // „Jahreszeit automatisch“: Weihnachten, Winter, Frühling, Sommer, Herbst (optional Halloween)
  const seasonMotif = () => {
    const now = md();
    // Anlass (Zeit: Rituale & Anlässe) hat Vorrang
    if (TMX && TMX.cfg.occFx && TMX.occasion) {
      const occ = { valentin: 'heart', muttertag: 'heart', ostern: 'spring', halloween: 'bat', blackfriday: 'bolt', nikolaus: 'xmas', weihnachten: 'xmas', silvester: 'confetti' }[TMX.occasion.key];
      if (occ) return occ;
    }
    // Tageszeit-Stimmung: morgens Tau, an Sommerabenden Glühwürmchen
    if (TMX && TMX.cfg.mood) {
      const h = TMX.parts().h;
      if (now >= 601 && now < 901 && (h >= 20 || h < 2)) return 'firefly';
      if (h >= 5 && h < 9 && !(now >= 1201 || now < 301)) return 'dew';
    }
    if (now >= 1201 && now <= 1226) return 'xmas';
    if (now >= 1227 || now < 301) return 'winter';
    if (now < 601) return 'spring';
    if (now < 901) return 'summer';
    if (cfg.halloween && now >= 1015 && now <= 1031) return 'bat';
    return 'autumn';
  };
  const resolve = (m) => (m === 'season' ? seasonMotif() : m);

  /* ---------- Motive ---------- */
  const P = (d) => new Path2D(d);
  const paths = {
    skull: P('M12 2C6.5 2 3 5.8 3 10.5c0 3 1.4 5.2 3.5 6.4V20a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-3.1c2.1-1.2 3.5-3.4 3.5-6.4C21 5.8 17.5 2 12 2ZM8.5 9.3a2.1 2.1 0 1 0 0 4.2a2.1 2.1 0 1 0 0-4.2ZM15.5 9.3a2.1 2.1 0 1 0 0 4.2a2.1 2.1 0 1 0 0-4.2ZM12 14.2l-1.3 2.3h2.6Z'),
    bat: P('M12 8.6c-.5-1-1.2-1.6-1.2-1.6l-.4 1.4C8.7 7.2 5.4 6.8 1.5 8.8c2.1.6 3.2 2.1 3.4 3.8.9-.8 2.3-.9 3.2 0 .7-1 2.1-1.2 3-.3L12 14.6l.9-2.3c.9-.9 2.3-.7 3 .3.9-.9 2.3-.8 3.2 0 .2-1.7 1.3-3.2 3.4-3.8-3.9-2-7.2-1.6-8.9-.4l-.4-1.4s-.7.6-1.2 1.6Z'),
    heart: P('M12 21s-7.5-4.6-9.3-9.2C1.4 8.4 3.6 4.5 7.2 4.5c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.6 0 5.8 3.9 4.5 7.3C19.5 16.4 12 21 12 21Z'),
    spark: P('M12 1c.6 5.3 2.7 7.6 11 11-8.3 3.4-10.4 5.7-11 11-.6-5.3-2.7-7.6-11-11 8.3-3.4 10.4-5.7 11-11Z'),
    bolt: P('M13.5 1 4 13.5h6.5L9 23l10-13h-6.8L13.5 1Z'),
    leaf: P('M19.5 2.5C10.5 3 4 7.8 4 15c0 2 .5 3.6 1.3 4.9L2.6 22.6l1.2 1.1 2.6-2.6c1.4 1 3.2 1.6 5.4 1.6 6.6 0 8.9-8.6 7.7-20.2ZM7.3 19.6c2.2-4.6 5.4-8.4 9.6-11.6-3.1 3.6-5.6 7.4-7.6 12.4l-2-.8Z'),
    butterfly: P('M12 7.2c-1.2-3-4.6-5-8-4.6C2 2.9 2.4 6.7 3.6 8.8c1 1.6 3 2.3 4.6 2.4-2.6.6-4.2 2.6-3.6 4.8.7 2.6 4.1 3.3 6 1.4.6-.6 1.1-1.6 1.4-2.6.3 1 .8 2 1.4 2.6 1.9 1.9 5.3 1.2 6-1.4.6-2.2-1-4.2-3.6-4.8 1.6-.1 3.6-.8 4.6-2.4 1.2-2.1 1.6-5.9-.4-6.2-3.4-.4-6.8 1.6-8 4.6Z'),
    star: P('M12 1.5l3.1 6.6 7.2.9-5.3 5 1.4 7.1L12 17.6 5.6 21.1 7 14l-5.3-5 7.2-.9Z'),
    tree: P('M12 1 4.5 10.5H8L3.5 17H11v4.5h2V17h7.5L16 10.5h3.5Z'),
    ball: P('M12 6.5a7.5 7.5 0 1 0 0 15a7.5 7.5 0 1 0 0-15ZM10 3h4v3.2h-4Z')
  };

  const motifs = {
    skull: { shapes: ['skull'], colors: ['A', 'T'] },
    bat: { shapes: ['bat'], colors: ['T'], flap: true },
    heart: { shapes: ['heart'], colors: ['A', '#ff5fa2', '#c2185b'] },
    spark: { shapes: ['spark'], colors: ['#ffc928', 'A', '#ffe680'] },
    bolt: { shapes: ['bolt'], colors: ['#ffc928', 'A'] },
    confetti: { shapes: ['rect'], colors: ['A', '#ffc928', '#3ec1d3', '#7c4dff', '#ff6b35'], flip: true },
    spring: { shapes: ['blossom'], colors: ['#ffb7c5', '#ffd1dc', '#f7a1b5', '#fff0f5'], sway: 1.2 },
    summer: { shapes: ['butterfly'], colors: ['#f39c12', '#3498db', '#e84393', '#f1c40f'], flutter: true },
    autumn: { shapes: ['leaf'], colors: ['#d35400', '#e67e22', '#c0392b', '#a0522d', '#e1a925'], flip: true, sway: 1.4 },
    winter: { shapes: ['snow'], colors: ['#8cc8f0', '#b5dcf5', '#6fb0dd'], dark: ['#ffffff', '#e6f4ff', '#cfe9ff'], sway: 0.8, slow: 0.7 },
    xmas: { shapes: ['star', 'tree', 'ball'], colors: ['#c0392b', '#1e8449', '#d4ac0d'] },
    dew: { shapes: ['spark'], colors: ['#bfe6ff', '#ffffff', '#9fd3f5'], dark: ['#dff3ff', '#ffffff'], slow: 0.35, sway: 0.6 },
    firefly: { shapes: ['dot'], colors: ['#ffe066', '#fff3a6', '#d8f36b'], slow: 0.12, sway: 2.2, blink: true },
    image: { shapes: ['image'], colors: ['A', 'T'] },
    text: { shapes: ['text'], colors: ['T'] }
  };

  /* ---------- Farben ---------- */
  const probe = document.createElement('span');
  probe.style.display = 'none';
  document.body.append(probe);
  const cssColor = (v) => { probe.style.color = v; return getComputedStyle(probe).color; };
  let theme = {};
  const readTheme = () => {
    theme = { A: cssColor('var(--c-accent)'), T: cssColor('var(--c-text)'), B: cssColor('var(--c-bg)'), dark: document.documentElement.classList.contains('is-dark') };
  };
  readTheme();
  new MutationObserver(readTheme).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  const pick = (a) => a[Math.floor(Math.random() * a.length)];
  const colorFor = (m) => {
    if (cfg.colors === 'accent') return 'A';
    if (cfg.colors === 'rainbow') return `hsl(${Math.floor(Math.random() * 360)} 85% 60%)`;
    if (cfg.colors === 'custom') {
      const set = theme.dark && cfg.darkPalette.length ? cfg.darkPalette : cfg.palette;
      if (set.length) return pick(set);
    }
    return pick(theme.dark && m.dark ? m.dark : m.colors);
  };
  const paint = (c) => (c === 'A' ? theme.A : c === 'T' ? theme.T : c);

  let img = null;
  if (cfg.image) { img = new Image(); img.src = cfg.image; }
  // Eingefärbte Kopien der eigenen Grafik (z. B. einfarbige SVG), eine pro Farbe
  const tinted = new Map();
  const tintedImg = (color) => {
    if (!tinted.has(color)) {
      const c = document.createElement('canvas');
      c.width = 96;
      c.height = 96;
      const x = c.getContext('2d');
      x.drawImage(img, 0, 0, 96, 96);
      x.globalCompositeOperation = 'source-in';
      x.fillStyle = color;
      x.fillRect(0, 0, 96, 96);
      tinted.set(color, c);
    }
    return tinted.get(color);
  };

  /* ---------- Bühne ---------- */
  const canvas = document.createElement('canvas');
  canvas.className = 'fx-layer';
  canvas.setAttribute('aria-hidden', 'true');
  document.body.append(canvas);
  const ctx = canvas.getContext('2d');
  let W = 0;
  let H = 0;
  const resize = () => {
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  resize();
  window.addEventListener('resize', resize);

  const draw = (p) => {
    const s = p.size / 24;
    ctx.save();
    ctx.globalAlpha = Math.max(0, Math.min(1, p.alpha));
    ctx.translate(p.x, p.y);
    ctx.rotate(p.rot);
    let sx = s * p.scale;
    let sy = s * p.scale;
    if (p.m.flip) sy *= Math.cos(p.t * 3 + p.seed);
    if (p.m.flutter) sx *= 0.35 + 0.65 * Math.abs(Math.sin(p.t * 9 + p.seed));
    if (p.m.flap) sy *= 0.6 + 0.4 * Math.abs(Math.sin(p.t * 10 + p.seed));
    ctx.scale(sx, sy);
    ctx.translate(-12, -12);
    const col = paint(p.color);
    ctx.fillStyle = col;
    ctx.strokeStyle = col;
    switch (p.shape) {
      case 'rect':
        ctx.fillRect(6, 9, 12, 6);
        break;
      case 'dot':
        ctx.shadowColor = col;
        ctx.shadowBlur = 14;
        ctx.beginPath();
        ctx.arc(12, 12, 4, 0, Math.PI * 2);
        ctx.fill();
        break;
      case 'blossom':
        for (let i = 0; i < 5; i++) {
          const a = (i / 5) * Math.PI * 2;
          ctx.beginPath();
          ctx.ellipse(12 + Math.cos(a) * 5, 12 + Math.sin(a) * 5, 4.6, 3.4, a, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.fillStyle = '#f6c945';
        ctx.beginPath();
        ctx.arc(12, 12, 2.6, 0, Math.PI * 2);
        ctx.fill();
        break;
      case 'snow':
        ctx.lineWidth = 1.8;
        ctx.lineCap = 'round';
        for (let i = 0; i < 3; i++) {
          ctx.save();
          ctx.translate(12, 12);
          ctx.rotate((i * Math.PI) / 3);
          ctx.beginPath();
          ctx.moveTo(0, -10); ctx.lineTo(0, 10);
          ctx.moveTo(-3, -7); ctx.lineTo(0, -4.5); ctx.lineTo(3, -7);
          ctx.moveTo(-3, 7); ctx.lineTo(0, 4.5); ctx.lineTo(3, 7);
          ctx.stroke();
          ctx.restore();
        }
        break;
      case 'image':
        if (img && img.complete && (img.naturalWidth || img.width)) ctx.drawImage(cfg.tint ? tintedImg(col) : img, 0, 0, 24, 24);
        break;
      case 'text':
        ctx.font = '20px system-ui, "Apple Color Emoji", "Segoe UI Emoji", sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(cfg.text || '🖤', 12, 13);
        break;
      default:
        // Sticker-Kontur in Hintergrundfarbe: sichtbar auf hellen und dunklen Flächen
        ctx.lineWidth = 2.4 / Math.max(0.4, p.scale);
        ctx.lineJoin = 'round';
        ctx.strokeStyle = theme.B;
        ctx.stroke(paths[p.shape]);
        ctx.fill(paths[p.shape], 'evenodd');
    }
    ctx.restore();
  };

  const make = (motifKey, x, y, size, extra) => {
    const m = motifs[motifKey] || motifs.skull;
    return {
      m, x, y, size, shape: pick(m.shapes), color: colorFor(m),
      rot: (Math.random() - 0.5) * 0.8, vr: (Math.random() - 0.5) * 2,
      vx: 0, vy: 0, alpha: 1, scale: 1, t: 0, age: 0, seed: Math.random() * 10, ...extra
    };
  };

  /* Nachtmodus (23–6 Uhr): halb so viele Teilchen, keine Maus-Spur */
  const quiet = Boolean(TMX && TMX.cfg.quiet && (() => { const h = TMX.parts().h; return h >= 23 || h < 6; })());
  if (quiet) {
    cfg.trail = null;
    if (cfg.fall) cfg.fall.count = Math.ceil(cfg.fall.count / 2);
  }

  /* ---------- Fallende Teilchen ---------- */
  const fall = [];
  // Ende: endlos, nach einer Gesamtzahl oder nach einer Dauer; optional nur einmal pro Besuch
  const fallEnd = cfg.fall ? cfg.fall.end || 'endless' : 'endless';
  const limited = fallEnd !== 'endless';
  const onceKey = 'softriot:fx-fall-done';
  if (cfg.fall && limited && cfg.fall.once) {
    try { if (sessionStorage.getItem(onceKey)) cfg.fall = null; } catch (_) { /* egal */ }
  }
  let spawned = 0;
  let fallStart = 0;
  let fallStopped = false;
  if (cfg.fall) {
    const motif = resolve(cfg.fall.motif);
    const m = motifs[motif] || motifs.skull;
    let n = Math.min(80, cfg.fall.count);
    if (fallEnd === 'total') n = Math.min(n, cfg.fall.total);
    for (let i = 0; i < n; i++) {
      const size = cfg.fall.size * (0.6 + Math.random() * 0.6);
      // Mit Ende starten alle oberhalb des Bildes, sonst verteilt über die Seite
      const p = make(motif, Math.random() * W, limited ? -size - Math.random() * H : Math.random() * H, size);
      p.vy = (38 + Math.random() * 46) * (cfg.fall.speed / 100) * (m.slow || 1) * (0.7 + size / cfg.fall.size * 0.3);
      p.sway = (0.4 + Math.random()) * (m.sway || 1);
      fall.push(p);
      spawned += 1;
    }
  }
  // Darf ein unten angekommenes Teilchen oben neu starten?
  const mayRespawn = (now) => {
    if (fallStopped) return false;
    if (fallEnd === 'total' && spawned >= cfg.fall.total) fallStopped = true;
    if (fallEnd === 'time' && now - fallStart > cfg.fall.seconds * 1000) fallStopped = true;
    if (fallStopped && cfg.fall.once) { try { sessionStorage.setItem(onceKey, '1'); } catch (_) { /* egal */ } }
    return !fallStopped;
  };
  const windAt = (time) => {
    switch (cfg.fall && cfg.fall.wind) {
      case 'left': return -28;
      case 'right': return 28;
      case 'gusty': return Math.sin(time / 4200) * 36 + Math.sin(time / 1300) * 8;
      default: return 0;
    }
  };

  /* ---------- Maus-Spur ---------- */
  const trail = [];
  const swarm = [];
  const T = cfg.trail;
  const tMotif = T ? resolve(T.motif) : null;
  let lastX = null;
  let lastY = null;
  let lastMove = 0;
  let mouseX = W / 2;
  let mouseY = H / 2;
  // Pause nur über Bedienelementen (ganze Produktkarten sind Links und zählen nicht)
  const interactive = 'button, input, select, textarea, label, summary, [role="button"], .btn, .drawer, .menu, .popup';
  const blocked = (target) => document.body.classList.contains('is-locked') || (target && target.closest && target.closest(interactive));

  const spawn = (x, y, burst) => {
    if (trail.length > 70) return;
    const n = burst ? 6 + T.amount * 3 : T.amount;
    for (let i = 0; i < n; i++) {
      const size = T.size * (0.7 + Math.random() * 0.5);
      const p = make(tMotif, x + (Math.random() - 0.5) * 8, y + (Math.random() - 0.5) * 8, size, { life: T.life });
      if (burst) {
        const a = Math.random() * Math.PI * 2;
        const v = 120 + Math.random() * 220;
        p.vx = Math.cos(a) * v;
        p.vy = Math.sin(a) * v - 120;
        p.g = 520;
      } else if (T.style === 'scatter') {
        p.vx = (Math.random() - 0.5) * 140;
        p.vy = -60 - Math.random() * 120;
        p.g = 420;
      } else if (T.style === 'sticker') {
        p.scale = 0;
        p.rot = (Math.random() - 0.5) * 0.6;
        p.vr = 0;
      } else {
        p.vx = (Math.random() - 0.5) * 30;
        p.vy = (Math.random() - 0.5) * 30 + 10;
      }
      trail.push(p);
    }
  };

  const onMove = (x, y, target) => {
    mouseX = x;
    mouseY = y;
    lastMove = performance.now();
    if (blocked(target)) { lastX = null; return; }
    if (T.style === 'click') return;
    if (T.style === 'swarm') { wake(); return; }
    if (lastX === null) { lastX = x; lastY = y; return; }
    const step = T.style === 'sticker' ? 46 : 16;
    if (Math.hypot(x - lastX, y - lastY) < step) return;
    lastX = x;
    lastY = y;
    spawn(x, y, false);
    wake();
  };

  if (T) {
    document.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse' && !cfg.mobile) return;
      onMove(e.clientX, e.clientY, e.target);
    }, { passive: true });
    if (cfg.mobile) {
      document.addEventListener('touchmove', (e) => {
        const tch = e.touches[0];
        if (tch) onMove(tch.clientX, tch.clientY, e.target);
      }, { passive: true });
    }
    if (T.style === 'click') {
      document.addEventListener('pointerdown', (e) => {
        if (blocked(e.target)) return;
        spawn(e.clientX, e.clientY, true);
        wake();
      }, { passive: true });
    }
    if (T.style === 'swarm') {
      const n = Math.min(14, 3 + T.amount * 2);
      for (let i = 0; i < n; i++) {
        const p = make(tMotif, mouseX, mouseY, T.size * (0.7 + Math.random() * 0.5));
        p.ox = (Math.random() - 0.5) * 90;
        p.oy = (Math.random() - 0.5) * 70;
        p.ease = 2 + Math.random() * 3;
        p.alpha = 0;
        swarm.push(p);
      }
    }
  }

  /* ---------- Schleife ---------- */
  let running = false;
  let prev = 0;
  const loop = (now) => {
    const dt = Math.min(0.05, (now - prev) / 1000 || 0.016);
    prev = now;
    ctx.clearRect(0, 0, W, H);

    if (fall.length) {
      if (!fallStart) fallStart = now;
      const wind = windAt(now);
      fall.forEach((p) => {
        p.t += dt;
        p.y += p.vy * dt;
        p.x += (wind + Math.sin(p.t * p.sway + p.seed) * 22 * p.sway) * dt;
        p.rot += p.vr * dt * 0.6;
        if (p.y > H + p.size) {
          if (!limited || mayRespawn(now)) { p.y = -p.size; p.x = Math.random() * W; spawned += 1; } else { p.gone = true; return; }
        }
        if (p.x > W + p.size) p.x = -p.size;
        if (p.x < -p.size) p.x = W + p.size;
        p.alpha = p.m.blink ? 0.25 + 0.75 * Math.abs(Math.sin(p.t * 1.6 + p.seed)) : 0.9;
        draw(p);
      });
      // Teilchen, die nach dem Ende unten angekommen sind, verschwinden
      for (let i = fall.length - 1; i >= 0; i--) if (fall[i].gone) fall.splice(i, 1);
    }

    for (let i = trail.length - 1; i >= 0; i--) {
      const p = trail[i];
      p.t += dt;
      p.age += dt;
      const k = p.age / p.life;
      if (k >= 1) { trail.splice(i, 1); continue; }
      if (T.style === 'sticker') {
        // aufploppen, kleben, dann ablösen und fallen
        p.scale = p.age < 0.18 ? (p.age / 0.18) * 1.15 : Math.max(1, 1.15 - (p.age - 0.18) * 1.5);
        if (k > 0.65) { p.vy += 900 * dt; p.vr = 3; p.alpha = 1 - (k - 0.65) / 0.35; }
      } else {
        p.alpha = 1 - k;
        p.scale = 1 - k * 0.45;
      }
      if (p.g) p.vy += p.g * dt;
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.rot += p.vr * dt;
      draw(p);
    }

    if (swarm.length) {
      const idle = now - lastMove > 1400 || blocked(null);
      swarm.forEach((p, i) => {
        p.t += dt;
        const tx = mouseX + p.ox + Math.sin(p.t * 2 + i) * 14;
        const ty = mouseY + p.oy + Math.cos(p.t * 2.4 + i) * 10;
        p.x += (tx - p.x) * Math.min(1, dt * p.ease);
        p.y += (ty - p.y) * Math.min(1, dt * p.ease);
        p.rot = Math.max(-0.5, Math.min(0.5, (tx - p.x) / 120));
        p.alpha += ((idle ? 0 : 1) - p.alpha) * Math.min(1, dt * 4);
        if (p.alpha > 0.01) draw(p);
      });
    }

    const swarmAwake = swarm.some((p) => p.alpha > 0.01) || now - lastMove < 1600;
    if (fall.length || trail.length || (swarm.length && swarmAwake)) {
      requestAnimationFrame(loop);
    } else {
      running = false;
      ctx.clearRect(0, 0, W, H);
    }
  };
  function wake() {
    if (running || document.hidden) return;
    running = true;
    prev = performance.now();
    requestAnimationFrame(loop);
  }
  document.addEventListener('visibilitychange', () => { if (!document.hidden) wake(); });
  if (fall.length) wake();
})();
